export function ResetLayoutAspect(resetLayout){
    return {
        resetLayout
    }
}